<template>
  <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
  <div id="app">
    <keep-alive include="MyLayout">
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
import { onMounted, onUnmounted } from 'vue'
export default {
  name: 'App',
//   components: {
//     HelloWorld
//   }
setup(){
  onMounted(()=>{
  })
  onUnmounted(()=>{
    localStorage.removeItem('futureDays')
  })
},
}
</script>

<style scoped>
  #app{
  }
</style>
